import { Link } from 'react-router-dom';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';

export default function Recruit() {
  const positions = [
    {
      title: '3tトラックドライバー',
      type: '正社員',
      salary: '月給28万円〜32万円',
      location: '京都府八幡戸津東代64-1',
      requirements: [
        '中型免許(8t限定可)',
        '運転経験2年以上',
        '年齢20歳〜55歳',
        '健康で体力に自信のある方'
      ],
      benefits: [
        '各種社会保険完備',
        '免許取得支援制度',
        '昇給年1回',
        '賞与年2回'
      ],
      workTime: 'コースにより変動あり(実働8時間程度)',
      holidays: '配属コースにより変動あり',
      image: 'https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/3856c98210813fe692b0a9b63551e336.jpeg'
    },
    {
      title: '4tトラックドライバー',
      type: '正社員',
      salary: '月給30万円〜35万円',
      location: '京都府八幡戸津東代64-1',
      requirements: [
        '中型免許',
        '運転経験3年以上',
        '年齢20歳〜55歳',
        'フォークリフト免許歓迎'
      ],
      benefits: [
        '各種社会保険完備',
        '免許取得支援制度',
        '昇給年1回',
        '賞与年2回'
      ],
      workTime: 'コースにより変動あり(実働8時間程度)',
      holidays: '配属コースにより変動あり',
      image: 'https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/3856c98210813fe692b0a9b63551e336.jpeg'
    },
    {
      title: '軽貨物ドライバー',
      type: '業務委託',
      salary: '月収25万円〜30万円',
      location: '関西圏全域',
      requirements: [
        '普通免許',
        '軽貨物車両持込可能な方',
        '年齢20歳〜55歳',
        'やる気のある方'
      ],
      benefits: [
        '高単価案件多数',
        '自由な働き方',
        '車両リース制度',
        '燃料費補助'
      ],
      workTime: '自由シフト制',
      holidays: '自由設定',
      image: 'https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/3856c98210813fe692b0a9b63551e336.jpeg'
    }
  ];

  const companyBenefits = [
    {
      icon: 'ri-shield-check-line',
      title: '充実の保険制度',
      description: '健康保険・厚生年金・雇用保険・労災保険完備'
    },
    {
      icon: 'ri-graduation-cap-line',
      title: '免許取得支援',
      description: '大型免許・フォークリフト免許の取得費用を会社が負担'
    },
    {
      icon: 'ri-line-chart-line',
      title: '昇給・昇格制度',
      description: '年1回の昇給査定と能力に応じた昇格制度'
    },
    {
      icon: 'ri-calendar-check-line',
      title: '完全週休2日制',
      description: '土日祝日休み、年間休日120日以上'
    },
    {
      icon: 'ri-car-line',
      title: '車両貸与',
      description: '業務用車両は会社が用意、維持費も会社負担'
    },
    {
      icon: 'ri-team-line',
      title: '若い職場環境',
      description: '平均年齢30代前半、活気ある職場で成長できる'
    }
  ];

  const workEnvironment = [
    {
      title: '安全第一の職場',
      description: '定期的な安全講習と車両点検で事故ゼロを目指します',
      icon: 'ri-shield-star-line'
    },
    {
      title: 'チームワーク重視',
      description: '困った時はお互いに助け合う、温かい職場環境',
      icon: 'ri-team-line'
    },
    {
      title: '最新設備完備',
      description: 'GPS搭載車両とデジタル配車システムで効率的な業務',
      icon: 'ri-smartphone-line'
    },
    {
      title: '成長をサポート',
      description: '個人の成長を会社全体でサポートする教育制度',
      icon: 'ri-rocket-line'
    }
  ];

  const recruitmentProcess = [
    {
      step: '01',
      title: '応募',
      description: 'Webフォームまたはお電話でご応募',
      icon: 'ri-send-plane-line'
    },
    {
      step: '02',
      title: '書類選考',
      description: '履歴書・職務経歴書による書類選考',
      icon: 'ri-file-text-line'
    },
    {
      step: '03',
      title: '面接',
      description: '代表との面接（1回）',
      icon: 'ri-user-voice-line'
    },
    {
      step: '04',
      title: '内定・入社',
      description: '条件面談後、入社日を調整',
      icon: 'ri-check-double-line'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* ヒーローセクション */}
      <section 
        className="relative h-96 flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(30, 58, 138, 0.8), rgba(30, 58, 138, 0.8)), url('https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/2e247cc529e1bb5abd7f2c0fe44e168e.jpeg')`
        }}
      >
        <div className="text-center text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">採用情報</h1>
          <p className="text-xl text-blue-200">Recruitment</p>
        </div>
      </section>

      {/* 採用メッセージ */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-6">
              一緒に未来の物流を創りませんか？
            </h2>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
              SUNFIELDは2023年に設立された新しい会社です。若い力で物流業界に新たな風を吹き込み、
              お客様に信頼される物流パートナーを目指しています。
              あなたの経験と情熱で、一緒に会社を成長させていきませんか？
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-2xl font-bold text-blue-900 mb-6">代表からのメッセージ</h3>
              <p className="text-gray-700 mb-4 leading-relaxed">
                SUNFIELDでは、一人ひとりの成長を大切にしています。経験者の方はもちろん、
                未経験の方でもしっかりとサポートしますので、安心してご応募ください。
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed">
                私たちと一緒に、安全で確実な物流サービスを通じて社会に貢献し、
                お客様から信頼される会社を築いていきましょう。
              </p>
              <div className="flex items-center">
                <div className="w-16 h-16 bg-blue-900 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-user-line text-white text-2xl"></i>
                </div>
                <div>
                  <p className="font-bold text-blue-900 text-lg">寸田翔馬</p>
                  <p className="text-gray-600">代表取締役</p>
                </div>
              </div>
            </div>
            <div>
              <img
                src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/9968523a99f6b3647e9b47b9eea31436.jpeg"
                alt="代表からのメッセージ"
                className="rounded-xl shadow-lg w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* 募集職種 */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              募集職種
            </h2>
            <p className="text-xl text-gray-600">
              あなたに合った働き方を見つけてください
            </p>
          </div>

          <div className="space-y-8">
            {positions.map((position, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                  <div className="lg:col-span-1">
                    <img
                      src={position.image}
                      alt={position.title}
                      className="w-full h-64 lg:h-full object-cover object-top"
                    />
                  </div>
                  <div className="lg:col-span-2 p-6 lg:p-8">
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-2xl font-bold text-blue-900">{position.title}</h3>
                      <span className="bg-yellow-400 text-blue-900 px-3 py-1 rounded-full text-sm font-semibold">
                        {position.type}
                      </span>
                    </div>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                      <div>
                        <h4 className="font-semibold text-blue-900 mb-2">給与</h4>
                        <p className="text-gray-700 text-lg font-semibold">{position.salary}</p>
                      </div>
                      <div>
                        <h4 className="font-semibold text-blue-900 mb-2">勤務地</h4>
                        <p className="text-gray-700">{position.location}</p>
                      </div>
                      <div>
                        <h4 className="font-semibold text-blue-900 mb-2">勤務時間</h4>
                        <p className="text-gray-700">{position.workTime}</p>
                      </div>
                      <div>
                        <h4 className="font-semibold text-blue-900 mb-2">休日</h4>
                        <p className="text-gray-700">{position.holidays}</p>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <h4 className="font-semibold text-blue-900 mb-3">応募資格</h4>
                        <ul className="space-y-1">
                          {position.requirements.map((req, reqIndex) => (
                            <li key={reqIndex} className="flex items-start text-sm text-gray-700">
                              <i className="ri-check-line text-green-500 mr-2 mt-0.5 flex-shrink-0"></i>
                              {req}
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div>
                        <h4 className="font-semibold text-blue-900 mb-3">待遇・福利厚生</h4>
                        <ul className="space-y-1">
                          {position.benefits.map((benefit, benefitIndex) => (
                            <li key={benefitIndex} className="flex items-start text-sm text-gray-700">
                              <i className="ri-star-line text-yellow-400 mr-2 mt-0.5 flex-shrink-0"></i>
                              {benefit}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 福利厚生 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              充実の福利厚生
            </h2>
            <p className="text-xl text-gray-600">
              安心して長く働ける環境を整えています
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {companyBenefits.map((benefit, index) => (
              <div key={index} className="bg-gray-50 rounded-xl p-6 text-center border border-gray-200">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-900 to-blue-800 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${benefit.icon} text-2xl text-yellow-400`}></i>
                </div>
                <h3 className="text-lg font-bold text-blue-900 mb-3">{benefit.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 職場環境 */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              職場環境
            </h2>
            <p className="text-xl text-gray-600">
              働きやすい環境づくりに取り組んでいます
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {workEnvironment.map((env, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg p-8 flex items-start">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className={`${env.icon} text-blue-900 text-xl`}></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-blue-900 mb-3">{env.title}</h3>
                  <p className="text-gray-700 leading-relaxed">{env.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 採用プロセス */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              採用プロセス
            </h2>
            <p className="text-xl text-gray-600">
              応募から入社までの流れ
            </p>
          </div>

          <div className="relative">
            {/* プロセスライン */}
            <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-blue-200 transform -translate-y-1/2"></div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {recruitmentProcess.map((process, index) => (
                <div key={index} className="relative">
                  <div className="bg-white border-4 border-blue-900 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4 relative z-10">
                    <span className="text-blue-900 font-bold text-lg">{process.step}</span>
                  </div>
                  <div className="text-center">
                    <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                      <i className={`${process.icon} text-blue-900 text-xl`}></i>
                    </div>
                    <h3 className="text-lg font-bold text-blue-900 mb-2">{process.title}</h3>
                    <p className="text-gray-600 text-sm leading-relaxed">{process.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 応募フォーム */}
      <section className="py-20 bg-blue-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            あなたのご応募をお待ちしています
          </h2>
          <p className="text-xl text-blue-200 mb-8">
            まずはお気軽にお問い合わせください。詳しい条件や職場見学も可能です。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="bg-yellow-400 text-blue-900 px-8 py-4 rounded-full font-bold text-lg hover:bg-yellow-300 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-send-plane-line mr-2"></i>
              応募・お問い合わせ
            </Link>
            <a
              href="tel:090-9801-4659"
              className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-blue-900 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill mr-2"></i>
              090-9801-4659
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
